// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"51ca3a43","592":"9fae9faa"}[chunkId] + ".chunk.js";
};